export default __webpack_public_path__ + "assets/images/ba65efa8387da0a3db7473b7badf3b77.svg";